import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=0c9dcd36&scoped=true&"
import script from "./MsgDialog.vue?vue&type=script&lang=ts&"
export * from "./MsgDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&id=0c9dcd36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9dcd36",
  null
  
)

export default component.exports